import FormattedRecordTimestamp from '../../../utils/FormattedRecordTimestamp';
import { Tag } from '../../tags/types';

export const useTagsTableColumns = () => {
    return [
        { accessor: 'name', title: 'Name' },
        { accessor: 'description', title: 'Description' },
        { accessor: 'createdByUsername', title: 'Owner' },
        { accessor: 'created', title: 'Created', render: (row: Tag) => (
            <FormattedRecordTimestamp record={row} propertyName="created" />
        )}
    ];
};
